import React from "react";
import Accordion from "./Accordion";

import data from "./data";

import "./outline.styles.css";


const Outline = () => {
  return (
    <div className="outline__wrapper">
      <div className="outline__accordion">
        {data.map((datum) => {
          return <Accordion datum={datum} key={datum.id} />;
        })}
      </div>
    </div>
  );
};

export default Outline;
